import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { toast } from "sonner";
import AuthShell from "./AuthShell";
import { api, apiError } from "@/lib/api";
import { inputCls, Field, GoldButton } from "@/components/app/widgets";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Reset your password"
      sub="We'll email you a secure reset link."
      footer={
        <Link to="/login" data-testid="back-to-login-link" className="text-[#D4AF37] hover:brightness-110">
          Back to sign in
        </Link>
      }
    >
      {sent ? (
        <div data-testid="forgot-sent" className="flex items-start gap-3 border border-emerald-700/40 bg-emerald-900/10 p-5">
          <MailCheck className="mt-0.5 h-5 w-5 shrink-0 text-emerald-400" />
          <p className="text-sm leading-relaxed text-zinc-300">
            If an account exists for <span className="text-white">{email}</span>, a reset link is on
            its way. It expires in 1 hour.
          </p>
        </div>
      ) : (
        <form onSubmit={submit} data-testid="forgot-form" className="space-y-5">
          <Field label="Email">
            <input
              type="email" required data-testid="forgot-email-input"
              value={email} onChange={(e) => setEmail(e.target.value)}
              className={inputCls} placeholder="you@company.com"
            />
          </Field>
          <GoldButton type="submit" disabled={loading} data-testid="forgot-submit-button" className="w-full py-3">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send Reset Link"}
          </GoldButton>
        </form>
      )}
    </AuthShell>
  );
}
